// extracted by mini-css-extract-plugin
export default {"container":"yellow_warning_icon-module___container___b29b6fd0","icon":"yellow_warning_icon-module___icon___ecc70c89","bar":"yellow_warning_icon-module___bar___b5de6c80"};